import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "49",
  fill: "none",
  viewBox: "0 0 48 49"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#EE8208",
      d: "M31.6 3.2H16.4c-6.6 0-9.9 0-11.95 2.05S2.4 10.6 2.4 17.2v15.2c0 6.6 0 9.9 2.05 11.95S9.8 46.4 16.4 46.4h15.2c6.6 0 9.9 0 11.95-2.05S45.6 39 45.6 32.4V17.2c0-6.6 0-9.9-2.05-11.95S38.2 3.2 31.6 3.2"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M21.039 30.375a12.4 12.4 0 0 1-3.838-1.59 1.94 1.94 0 0 1-.65-2.657 1.927 1.927 0 0 1 2.674-.667c.92.558 1.896.961 2.956 1.154 2.086.374 4.046.028 5.872-1.045.373-.22.75-.392 1.195-.389a1.95 1.95 0 0 1 1.866 1.378 1.93 1.93 0 0 1-.793 2.192 12.1 12.1 0 0 1-3.693 1.575l-.19.05c.053.058.094.105.139.148q1.754 1.753 3.506 3.508c.683.684.828 1.624.373 2.407-.651 1.13-2.152 1.316-3.093.382-1.165-1.16-2.324-2.324-3.486-3.485l-.173-.186c-.038.068-.06.134-.101.178a1153 1153 0 0 1-3.497 3.496c-.802.8-2.026.795-2.8-.002a1.94 1.94 0 0 1-.043-2.652c.091-.105.192-.203.29-.302l3.348-3.35.14-.143zm2.7-18.724a6.66 6.66 0 0 1 6.647 6.648 6.64 6.64 0 0 1-6.643 6.65 6.634 6.634 0 0 1-6.657-6.637 6.66 6.66 0 0 1 6.653-6.661m2.749 6.654a2.75 2.75 0 0 0-2.732-2.755c-1.528-.003-2.772 1.223-2.775 2.73-.003 1.511 1.224 2.77 2.702 2.77 1.568.002 2.803-1.207 2.805-2.745",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }